(function(window, undefined) {
    'use strict';
    angular.module('cbl.mitomanager.wa').constant('Mitom_CONSTANTS', {
        BASE_ROOT: '/CBL-MITOMANAGER-WA/app/',
        REST_ROOT: '/CBL-MITOMANAGER-MF/services/api-',
        REST_CLIENTI_ROOT: '/MSF-PROSPECTMANAGER-MF/api/',
        REST_MITO8_ROOT: '/CBL-MITO8CRM-MF/api/', 
        COMPONENTS_PATH: 'components/',

        ABILITAZIONI: {
            CONSOLIDA: { 
                "nomeFunzionalita": 'GestioneUtenzaMito',
                "nomeFunzionalitaLegacy": 'ValutazioneGestioneUtenteMitoBackOffice',
                "nomeParametroFunzionalita": 'Valutazione',
                "parametrizzazioneLegacy": false
            },
            MODIFICA: { 
                "nomeFunzionalita": 'GestioneUtenzaMito',
                "nomeFunzionalitaLegacy": 'ModificaUtenteMito',
                "nomeParametroFunzionalita": 'Modifica',
                "parametrizzazioneLegacy": false
            },
            ACCETTA: { 
                "nomeFunzionalita": 'GestioneUtenzaMito',
                "nomeFunzionalitaLegacy": 'ValutazioneGestioneUtenteMitoBackOffice',
                "nomeParametroFunzionalita": 'Valutazione',
                "parametrizzazioneLegacy": false
            },
            CREDENZIALI: { 
                "nomeFunzionalita": 'GestioneUtenzaMito',
                "nomeFunzionalitaLegacy": 'InvioCredenzialiMito',
                "nomeParametroFunzionalita": 'InvioCredenziali',
                "parametrizzazioneLegacy": false
            },
            SWITCH: { 
                "nomeFunzionalita": 'GestioneUtenzaMito',
                "nomeFunzionalitaLegacy": 'SwitchUtenzaMito',
                "nomeParametroFunzionalita": 'Switch',
                "parametrizzazioneLegacy": false
            },
            ESTINGUI: { 
                "nomeFunzionalita": 'GestioneUtenzaMito',
                "nomeFunzionalitaLegacy": 'EstinguiUtenzaMito',
                "nomeParametroFunzionalita": 'Estingui',
                "parametrizzazioneLegacy": false
            },
            RIBALTA: { 
                "nomeFunzionalita": 'GestioneUtenzaMito',
                "nomeFunzionalitaLegacy": 'RibaltamentoRapportiMito',
                "nomeParametroFunzionalita": 'RibaltamentoRapporti',
                "parametrizzazioneLegacy": false
            },
            AUDIT: { 
                "nomeFunzionalita": 'GestioneUtenzaMito',
                "nomeFunzionalitaLegacy": 'AuditEventiMito',
                "nomeParametroFunzionalita": 'AuditEventi',
                "parametrizzazioneLegacy": false
            },
            VIP: { 
                "nomeFunzionalita": 'GestioneUtenzaMito',
                "nomeFunzionalitaLegacy": 'GestioneVipMito',
                "nomeParametroFunzionalita": 'GestioneVip',
                "parametrizzazioneLegacy": false
            },
            INCARICATO: { 
                "nomeFunzionalita": 'GestioneUtenzaMito',
                "nomeFunzionalitaLegacy": 'ValutazioneGestioneUtenteMitoBackOffice',
                "nomeParametroFunzionalita": 'Valutazione',
                "parametrizzazioneLegacy": false
            }
        },

        PARAMETRI: {
            CONTROLLO_ACCETTAZIONE :'ControlloAccettazioneGestioneUtenteMito'
        },
        
        DOMINI_NOTIFICHE: {
            NESSUNO: '00',
            SMS: '01',
            EMAIL: '02'
        },

        REST: {
            GENERAL: {
                LABEL: 'generale/label',
                USER: 'generale/utente',
                LOG: 'generale/log'
            },
            ANAGRAFICA: {
                RECUPERA: 'anagrafica',
                PROMOTORE: 'anagrafica/promotore',
                CONTATTI: 'anagrafica/contatti'
            },
            DOMINI: {
                CATEGORIA_UTENTE: 'dominio/categoriautente/',
                CATEGORIA_MFWEB: 'dominio/categoriamfweb/',
                CAUSALI: 'dominio/causali',
                CONFIGURAZIONI: 'dominio/configurazioni/',
                MODALITA_INVIO: 'dominio/modalitaInvio'
            },
            MITO: {
                DETTAGLIO: 'utenze/',
                LISTA: 'utenze/lista/',
                LISTA_RAPPORTI: 'utenze/rapportiVisibili/',
                CLASSIFICAZIONE: 'utenze/classificazione/',
                ULTIMI_ACCESSI: 'utenze/ultimi-accessi/',
                LISTA_STATI: 'dominio/statiRaggiungibili/',
                LISTA_TUTTI_STATI: 'dominio/statiUtente/',
                CERTIFICAZIONE: 'utenze/certificazione-contatto/',
                CONTI_ADDEBITO: 'utenze/lista-conti-addebito/',
                ESTINGUI: 'utenze/estingui-mito/',
                RIBALTA: 'utenze/ribalta-rapporti/'
            },
            MITO8: {
                DNS: 'utenze/dns-mito/',
                ATTIVAZIONE: 'Sessioni/creaAttivazione' 
            },
            CREDENZIALI: {
                CODICE: 'credenziali/codice',
                PASSWORD: 'credenziali/password',
                STORICO: 'credenziali/carica-invio/',
                LIMITI: 'utenze/limiti/',
                CHECK_CAD: 'utenze/verifica-cad/',
                RESET_CAD: 'utenze/reset-cad/',
                STORICO_CONTATTI: 'utenze/storico-contatti/'
            },
            VIP: {
                AGGIUNGI: 'vip/aggiungi',
                DISABILITA: 'vip/disabilita',
                AUTENTICA: 'vip/autentica',
                PUSH: 'vip/push',

                STORICO_UTENTE: 'vip/storicoUtenteSymantec/',
                STORICO_GLOBALE: 'vip/storicoUtenteGlobale/',
                STORICO_SMS: 'vip/caricaStoricoOtpSms/',
            },
            PRATICA: {
                DETTAGLIO: 'pratiche-utenze/',
                LISTA_RAPPORTI: 'pratiche-utenze/rapporti',
                WIZARD: 'pratiche-utenze/wizard/',
                DETTAGLIO_DA_ID: 'pratiche-utenze/carica-da-id/',
                RAPPORTI_DA_ID: 'pratiche-utenze/carica-rapporti/',
                DEFAULT_DTO: 'pratiche-utenze/creaPratica/',
                VARIA: 'pratiche-utenze/varia',
                SALVA: 'pratiche-utenze/salva',
                AVANZA: 'pratiche-utenze/avanza',
                PRESENTA: 'pratiche-utenze/presenta',
                ANNULLA: 'pratiche-utenze/annulla',
                CONSOLIDA: 'pratiche-utenze/consolida',
                ACCETTA: 'pratiche-utenze/accetta',
                REVISIONA: 'pratiche-utenze/revisiona',
                INCORSO: 'pratiche-utenze/metti-in-corso',
                PRENDIINCARICO: 'pratiche-utenze/prendiInCarico',
                RILASCIA: 'pratiche-utenze/rilascia',
                RIFIUTA: 'pratiche-utenze/rifiuta',
                CREATORE: 'pratiche-utenze/creatorePratica/'
            },
            AUDIT: {
                SEARCH: 'Audit/caricaEventiUtentePaginata'
            }
        },

        MENU: {
            COMPONENTI: {
                TITLE: 'POSIZIONE',
                AUDIT: 'Audit utenza',
                CREDENZIALI: 'Credenziali',
                VIP: 'Storico VIP',
            },            
            SERVIZI: {
                TITLE: 'SERVIZI',
                SWITCH: 'Switch utenza',
                ESTINGUI: 'Estingui utenza',
                RIBALTA: 'Aggiorna visibilita\' rapporti',
            }
        }
    });
})(window);